import React from 'react';
import PropTypes from 'prop-types';
import * as formValidationHelper from '../../helpers/formValidationHelper';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import ReactDOM from 'react-dom';

export class MessagePanel extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isVisible: false
        };
        this.onShowValidator = this.onShowValidator.bind(this);
        this.onShowComplete = this.onShowComplete.bind(this);
        this.onHideValidator = this.onHideValidator.bind(this);
        this.onHideComplete = this.onHideComplete.bind(this);
    }



    componentDidMount(){
        this.onShowValidator();
    }

    componentWillReceiveProps(nextProps) {
        //let newPasswordState = formValidationHelper.validatePasswordCritea(nextProps.password);
        ///this.setState({passwordState: Object.assign({}, newPasswordState)});
        if(!this.state.isVisible && nextProps.show){
            //this.onShowValidator();
        }
    }

    componentWillUnmount(){
        if(this.state.isVisible){
            this.onHideValidator();
        }
    }

    onShowValidator(){

       let validator = this.refs.message;
        TweenLite.set(validator, {zIndex:100});
        TweenLite.to(validator, 0.5, {opacity: 1, ease: Expo.easeIn}).eventCallback("onComplete", this.onShowComplete);
    }

    onShowComplete(){
        this.setState({isVisible: true});
    }

    onHideValidator(){
        let validator = this.refs.message;
        TweenLite.to(validator, 0.5, {opacity: 0, ease: Expo.easeOut}).eventCallback("onComplete", this.onHideComplete);
    }

    onHideComplete(){
        let validator = this.refs.validator;
        TweenLite.set(validator, {zIndex:0});
        this.setState({isVisible: false});
        //this.props.onHide();
    }




    render() {
        return (
            <div className={"validation-panel " + this.props.alignment} ref="message" >
                <div className="padding">{this.props.message}</div>
            </div>
        );
    }
}

MessagePanel.propTypes = {
    name:PropTypes.string.isRequired,
    message: PropTypes.string,
    alignment: PropTypes.string,
    show: PropTypes.bool,
};


export default MessagePanel;



/** WEBPACK FOOTER **
 ** ./src/components/form/MessagePanel.js
 **/